import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _Icon;
import { forwardRef, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { FALLBACK_ICON, SVG_LIB_BASE_PATH } from '../Icon/icon-consts';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var getIconDimensions = function getIconDimensions(size) {
  if (typeof size === 'number') return {
    height: 'fit-content',
    width: size
  };
  if (size === 'lg') {
    return {
      height: 40,
      width: 58
    };
  }
  if (size === 'md') {
    return {
      height: 32,
      width: 46
    };
  }
  return {
    height: 24,
    width: 34
  }; //default to sm
};

/**
 * Renders a payment svg image icon from the Zenith SVG library.
 */
export var PaymentIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    src = _ref.src,
    sx = _ref.sx;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var alt = id.split('-').join(' ');
  var sizeModifier = typeof size === 'number' ? '_sm' : "_".concat(size);
  var svgPath = "".concat(SVG_LIB_BASE_PATH, "/misc/payment/").concat(id).concat(sizeModifier, ".svg");
  var srcToRender = function () {
    if (error) return '';
    if (src) return src;
    return svgPath;
  }();
  var handleImgError = function handleImgError() {
    if (!error) {
      setError(true);
    }
  };
  var sizeToRender = getIconDimensions(size);
  useEffect(function () {
    setError(false);
  }, [id]);
  return /*#__PURE__*/_jsx(Box, {
    "data-name": "Icon-".concat(id),
    "data-testid": "Icon-".concat(id),
    ref: ref,
    sx: _extends({
      alignItems: 'center',
      display: 'flex',
      height: sizeToRender.height,
      justifyContent: 'center',
      width: sizeToRender.width
    }, sx),
    children: error ? _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      iconId: FALLBACK_ICON
    })) : /*#__PURE__*/_jsx("img", {
      alt: alt,
      height: sizeToRender.height,
      onError: handleImgError,
      src: srcToRender,
      width: sizeToRender.width
    })
  });
});